export default "__VITE_ASSET__Bw6$A4mh__"